module.exports = __webpack_public_path__ + "static/media/cominMag.44facc78.png";